/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


//   // Attach the resize event listener
//   window.addEventListener('resize', handleResize);

//   return { onUnload, onBlockSelect };
// }

// // Usage:
// const element = document.getElementById('your-element-id'); // Replace with the actual element
// const { onUnload, onBlockSelect } = initializeCollectionListSection(element);

// if($('.carousel-main')){
//     // 1st carousel, main
//     $('.carousel-main').flickity();
//     // 2nd carousel, navigation
//     $('.carousel-nav').flickity({
//       asNavFor: '.carousel-main',
//       contain: true,
//       pageDots: false
//     });
// }

document.addEventListener('algolia.hooks.initialize', function () {
  // Set the search placeholder
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function (options) {
    options.placeholder = "Search for products.....";
    return options;
  });

  // Modify the default facet limit
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacetLimitNumber', function (limit) {
    return 52;
  });

  // Add refinement list widget for each facet you want to have checkboxes
  algoliaShopify.hooks.registerHook('beforeInstantSearchFacets', function (facets) {
    facets.push({
      type: 'refinementList',
      attribute: 'category', // Change 'category' to your desired facet attribute
      operator: 'and',
      templates: {
        item: `
          <label>
            <input type="checkbox" value="{{value}}" />
            <span>{{label}}</span>
          </label>
        `
      }
    });

    // Add other facets similarly if needed
    facets.push({
      type: 'refinementList',
      attribute: 'color', // Example for another facet
      operator: 'and',
      templates: {
        item: `
          <label>
            <input type="checkbox" value="{{value}}" />
            <span>{{label}}</span>
          </label>
        `
      }
    });

    return facets;
  });
  // Function to collapse all facets
  const collapseAllFacets = () => {
    const facetWrappers = document.querySelectorAll('.ais-facet-dropdown-wrapper');
    console.log("Number of facets found: ", facetWrappers.length);

    facetWrappers.forEach(wrapper => {
      const checkbox = wrapper.querySelector('input[type="checkbox"]');
      const dropdownContainer = wrapper.querySelector('.ais-facet-dropdown-container');

      if (checkbox && dropdownContainer) {
        console.log(`Collapsing facet with checkbox id: "${checkbox.id}".`);
        checkbox.checked = false; // Uncheck to collapse
        dropdownContainer.style.display = 'none'; // Hide the dropdown container
      } else {
        console.log("No checkbox or dropdown container found in wrapper: ", wrapper);
      }
    });
  };

  // Monitor for changes in the refinement list containers to re-collapse if needed
  const observeFacetChanges = () => {
    const facetsContainer = document.querySelector('.ais-facets');

    if (facetsContainer) {
      const observer = new MutationObserver(function () {
        console.log("Mutation detected, collapsing facets.");
        collapseAllFacets(); // Collapse facets whenever DOM changes are detected
      });

      // Observe the facets container for any changes in the DOM
      observer.observe(facetsContainer, { childList: true, attributes: true, subtree: true });
      console.log("Started observing facet changes.");
    } else {
      console.error("No facets container found.");
    }
  };

  // Ensure facets are collapsed on page load
  document.addEventListener('DOMContentLoaded', function () {
    console.log("Page has loaded and DOMContentLoaded event triggered.");
    collapseAllFacets(); // Collapse facets on page load
    observeFacetChanges(); // Monitor for dynamic changes and re-collapse facets
  });

  // Ensure facets remain collapsed after every Algolia render
  algoliaShopify.hooks.registerHook('afterInstantSearchRender', function () {
    console.log("Algolia rendered. Collapsing facets again.");
    collapseAllFacets();
  });

  // Search dropdown close logic
  const waitForSearchElements = () => {
    const searchBar = document.querySelector('.aa-Form');
    const dropdown = document.querySelector('.aa-Panel--scrollable');

    if (searchBar && dropdown) {
      // Set the event listener only when elements are available
      document.addEventListener('click', function (event) {
        const isClickInsideSearch = searchBar.contains(event.target);
        const isClickInsideDropdown = dropdown.contains(event.target);

        if (!isClickInsideSearch && !isClickInsideDropdown) {
          const clearButton = searchBar.querySelector('.aa-ClearButton');
          if (clearButton) {
            // console.log('trying to close');
            // clearButton.click(); // <-- I removed this because it was causing an error
          }
        }
      });
    } else {
      setTimeout(waitForSearchElements, 500); // Retry after a delay if elements are not found yet
    }
  };

  // Start the search dropdown closing process
  waitForSearchElements();
});




// Ensure that handleItemClick is not declared more than once
if (typeof handleItemClick === 'undefined') {
  const handleItemClick = (e, line_item) => {
    const afterClick = new Event("algoliaShopify.autocomplete.hitClickAction");
    document.dispatchEvent(afterClick);

    if (algoliaShopify.config.analytics_enabled) {
      const clickData = {
        index: line_item.__autocomplete_indexName,
        eventName: "Added to cart",
        queryID: line_item.__autocomplete_queryID,
        objectIDs: [line_item.objectID],
      };
      algoliaShopify.saveForConversionTracking(clickData);
    }

    const customerCustomAction = algoliaShopify.hooks.triggerHooks(
      "afterAutocompleteProductClickAction",
      undefined,
      line_item
    );

    if (typeof customerCustomAction === "function") {
      customerCustomAction();
    }
  };
}

////// 
/// MK - 4 June 2024 adds "sku" to the autocomplete
///// 
document.addEventListener("algolia.hooks.initialize", function () {
  algoliaShopify.hooks.registerHook(
    "beforeAutocompleteProductTemplate",
    function (_defaultTemplate, templateOptions, distinct, itemLink) {
      // Modify default options, then return them
      const { html, item, components } = templateOptions;
      return html`
    <a
      href="${itemLink}"
      class="aa-ItemLink aa-ProductItem"
      onClick="${(event) => handleItemClick(event, item)}"
    >
      <div class="aa-ItemContent">
        <div class="aa-ItemPicture aa-ItemPicture--loaded">
          <img
            src="${algoliaShopify.helpers.compactImage(item)}"
            alt="${item.title}"
          />
          
        </div>
        <div class="aa-ItemContentBody">
          <div class="aa-ItemContentBrand">
            ${item.vendor}
          </div>
          <div class="aa-ItemContentTitleWrapper">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: "title" })}
              <span class="algolia-variant">
                ${algoliaShopify.helpers.variantTitleAddition(item, distinct)}
              </span>
            </div>
          </div>
          <div class="aa-ItemContentPrice" style="font-size:10px;">
          ${item.sku}
          </div>
          <div class="aa-ItemContentPrice">
            
            <div class="aa-ItemContentPriceCurrent">
              ${algoliaShopify.helpers.displayPrice(item, distinct)}
            </div>
            
          </div>
        </div>
      </div>
    </a>
  `;
    }
  );
});


// Modify Collection Layout
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function (_defaultTemplate, data, html) {
    return html`
      <div class="ais-page">
        <h1 class="ais-h2" style="display: none;">${algoliaShopify.translations.searchTitle}</h1>
        <div class="ais-input" style="display: none;">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button d-none">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-facets">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          ${data.facets.map(
      facet =>
        html`
                <div
                  class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                >
                  <label
                    for="${facet.escapedName}"
                    class="ais-range-slider--header ais-facet--header ais-header"
                    >${facet.title}</label
                  >
                  <input
                    class="ais-dropdown-checkbox"
                    type="checkbox"
                    id="${facet.escapedName}"
                    name="dropdown"
                  />
                  <div
                    class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                  ></div>
                </div>
              `
    )}
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-stats-container" style="display: none;"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
        ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
        : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });
});

// Modify Product Layout
document.addEventListener('algolia.hooks.initialize', function () {
  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function (_defaultTemplate, hit, html, components) {
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-variant-id="${hit.objectID}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
      >
        <img
          class="ais-hit--picture"
          src="${algoliaShopify.helpers.mediumImage(hit)}"
          alt="${hit.title} - ${hit.variant_title}"
        />

        <div class="ais-hit--details">
          <p class="ais-hit--price" style="text-overflow: unset;">
            <b>${algoliaShopify.helpers.displayPrice(hit, hit._distinct)}</b>
            ${!hit._distinct &&
      html`
                <span class="ais-hit--price-striked"
                  ><span
                  style="font-size: 12px;text-overflow: unset;" 
                  >${algoliaShopify.helpers.displayStrikedPrice(
        hit.price,
        hit.compare_at_price
      )}</span
                  ></span
                >
              `}
            ${!hit._distinct &&
      html`
                <span class="ais-hit--price-discount"
                style="display: none;"
                  >${algoliaShopify.helpers.displayDiscount(
        hit.sku,
        hit.compare_at_price,
        hit.price_ratio
      )}</span
                >
              `}
          </p>
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="${algoliaShopify.helpers.instantsearchLink(hit)}"
              onclick="void(0)"
              title="${algoliaShopify.helpers.fullTitle(
        hit.title,
        hit._distinct,
        hit.variant_title
      )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>
          <p
            class="ais-hit--subtitle"
            title="${hit.sku}"
          >
            ${components.Highlight({ attribute: 'sku', hit })}
          </p>
          <div data-flair-product-badge data-product-id="${hit.id}"></div> <!-- Add this line for Flair badge -->

          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
      html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
      html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
      html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
      html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
        tag =>
          html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
      )}
          </p>
          ${!hit._distinct &&
      html`
              <form
                id="algolia-add-to-cart-${hit.objectID}"
                style="display: none;"
                action="/cart/add"
                method="post"
                enctype="multipart/form-data"
              >
                <input type="hidden" name="id" value="${hit.objectID}" />
              </form>
              <p class="ais-hit--cart" style="display:none;">
                ${hit.can_order
          ? html`
                      <button
                        class="ais-hit--cart-button"
                        data-form-id="algolia-add-to-cart-${hit.objectID}"
                      >
                        ${algoliaShopify.translations.addToCart}
                      </button>
                    `
          : html`
                      <button
                        class="ais-hit--cart-button ais-hit--cart-button__disabled"
                      >
                        ${algoliaShopify.translations.outOfStock}
                      </button>
                    `}
              </p>
            `}
        </div>
      </div>
    `;
  });
});

// Reinitialize Flair badges after Algolia renders products
document.addEventListener('algolia.hooks.render', function () {
  if (typeof Flair !== 'undefined' && typeof Flair.load === 'function') {
    Flair.load(); // Ensure the Flair badges are re-initialized after Algolia renders the products
  }
});



